<template>
    <article v-if="usersList.length > 0" id="EmployeeCalendar__wrapper" class="calender-height">
        <FullCalendar :updatedOptions="calendarOptions" />
    </article>
</template>

<script lang="ts" src="./EmployeeCalendarContent.ts"></script>
